import React, { useEffect } from "react";
import { Loader2 } from "lucide-react";


/**
 * @type {import('react').FC<{path: string, query?: Record<string, string>}>}
 */
export default function DeepLinkRedirect({ path, query={} }) {
  const userAgent = navigator.userAgent || window.opera;
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  const redirectToApp = () => {
    const fullPath = Object.values(query).length ? `${path}?${new URLSearchParams(query).toString()}` : path;
    const appUrl = `squaay://${fullPath}`;
    // const appUrl = `exp://localhost:8081/--/${fullPath}`;

    let fallbackUrl = "https://squaay.com";
    if (isAndroid && !isIOS) fallbackUrl = "https://play.google.com/store/apps/details?id=com.squaay.android";
    if (isIOS && !isAndroid) fallbackUrl = "https://apps.apple.com/app/squaay/id6740501959";

    if (!appUrl) {
      window.location.href = fallbackUrl
      return
    }
    
    window.location.href = appUrl;

    setTimeout(() => window.location.href = fallbackUrl, 2000);
  }
  
  useEffect(redirectToApp, [isAndroid, isIOS, path, query]);

  return (
    <div className="flex flex-col flex-1 justify-center items-center border-2 border-black">
      <h1>Redirecting...</h1>
      <Loader2 className="w-16 h-16 text-[#F15A24] animate-spin" />
    </div>
  );
}
